import { useMutation } from "@tanstack/react-query";
import { resolveScopedVaultApi } from "../../../api/vault.api";

interface DownloadFileParams {
  fileId: string;
  filename: string;
}

export function useDownloadFile() {
  const scopedVaultApi = resolveScopedVaultApi(
    typeof window !== "undefined" ? window.location.pathname : "",
  );

  return useMutation({
    mutationFn: async ({ fileId, filename }: DownloadFileParams) => {
      const blob = await scopedVaultApi.downloadFile(fileId);
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setTimeout(() => URL.revokeObjectURL(url), 100);
    },
  });
}
